import React, { useMemo, useState } from 'react'
import { StyleSheet, ViewStyle } from 'react-native'
import { DNABox, DNAButton, DNAIcon, DNAText, util } from '@alucio/lux-ui'
import colors from '@alucio/lux-ui/src/theming/themes/alucio/colors'
import useCurrentPage from '../DNA/hooks/useCurrentPage'
import { useAppSettings } from 'src/state/context/AppSettings'

const styles = StyleSheet.create({
  container: {
    backgroundColor: colors['color-warning-500'],
    paddingLeft: 25,
    paddingRight: 45,
    minHeight: 50,
  },
  hiddenStyle: {
    display: 'none',
  },
  textColor: {
    color: colors['color-text-dark-primary'],
  },
})

const NetworkConnectionBanner:React.FC<{ style?: ViewStyle }> = (props) => {
  const { deviceMode, isOnline } = useAppSettings()
  const currentPage = useCurrentPage()
  /** Route config options */
  const {
    disableNetworkStatusBanner,
  } = { ...currentPage?.configOptions?.[deviceMode] }

  /** Used to hide the banner while we are still offline */
  const [isHidden, setIsHidden] = useState<boolean>(false)

  const containerStyle = useMemo(() => util.mergeStyles(
    undefined,
    props.style,
    styles.container,
    [styles.hiddenStyle, isHidden],
  ), [props.style, isHidden]);

  if (isOnline || disableNetworkStatusBanner) return null
  return (
    <DNABox fill alignY="center" spacing="between" style={containerStyle}>
      <DNABox fill alignY="center" spacing="md">
        <DNAIcon.Styled name="wifi-slash" appearance="filled" size="lg" />
        <DNAText b1 style={styles.textColor}>
          No internet connection. Some features will be unavailable in offline mode.
        </DNAText>
      </DNABox>
      <DNABox>
        <DNAButton status="warning" onPress={() => setIsHidden(true)} children="Hide" />
      </DNABox>
    </DNABox>
  )
}

export default NetworkConnectionBanner
